export default __webpack_public_path__ + "img/WB_NB_NOMA_EF.7f578a40ad69e7fba37732e13dba7968.jpg";